export const ADMIN_STORAGE_KEYS = {
  auth: 'swarup_admin_auth',
  services: 'swarup_admin_services',
  doctors: 'swarup_admin_doctors',
  blogs: 'swarup_admin_blogs',
  messages: 'swarup_admin_messages',
  appointments: 'swarup_admin_appointments',
  aboutStats: 'swarup_admin_about_stats'
};

export const loadStoredData = (key, fallback = null) => {
  if (typeof window === 'undefined') return fallback;
  try {
    const value = window.localStorage.getItem(key);
    return value ? JSON.parse(value) : fallback;
  } catch (error) {
    console.warn('Failed to read local admin data:', error);
    return fallback;
  }
};

export const saveStoredData = (key, value) => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.warn('Failed to save local admin data:', error);
  }
};

export const clearStoredData = (key) => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(key);
  } catch (error) {
    console.warn('Failed to clear local admin data:', error);
  }
};

export const persistAdminAuth = (email, password) => {
  saveStoredData(ADMIN_STORAGE_KEYS.auth, { email, password, fallback: true });
};

export const clearAdminAuth = () => {
  clearStoredData(ADMIN_STORAGE_KEYS.auth);
};

export const getStoredAdminAuth = () => loadStoredData(ADMIN_STORAGE_KEYS.auth, null);
